"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
const Resource_1 = __importDefault(require("../../Resource"));
class GenericConnaissanceExperienceResponseResource extends Resource_1.default {
}
exports.default = GenericConnaissanceExperienceResponseResource;
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "dejaSouscritScpi", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "dejaSouscritScpiPartPierval", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "dejaSouscritScpiNamePierval", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "nbSouscriptionsScpi", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "datePremiereSouscription", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "dateDerniereSouscription", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "experienceProfessionnelle", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], GenericConnaissanceExperienceResponseResource.prototype, "supportPlacementPossedez", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], GenericConnaissanceExperienceResponseResource.prototype, "supportPlacementConnaissez", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "scpiOpciNombreSouscriptions", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "scpiOpciFrequenceTransaction", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "scpiOpciMoyenneTransactionCout", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "modeGestionUtilise", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "nbOperationsDerniersMois", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "risqueRendementAccepter", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "connaissancesMarcheFinancierProduitsEpargne", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "combienTempsRealisezInvestissements", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "dejaPertePlacement", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "reactionChuteBrusqueValeurInvestissement", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "connaissancesMarcheImmobilier", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "experienceProfessionnelleCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], GenericConnaissanceExperienceResponseResource.prototype, "supportPlacementConnaissezCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], GenericConnaissanceExperienceResponseResource.prototype, "supportPlacementPossedezCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "dejaSouscritScpiCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "dejaSouscritScpiPartPiervalCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "dejaSouscritScpiNamePiervalCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "dejaSouscritScpiQuandCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "dejaSouscritScpiCombienCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "dejaSouscritScpiPremiereSouscriptionCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "dejaSouscritScpiTypeCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "dejaSouscritScpiTypeCorporationOther", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "dejaSouscritScpiPartCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "frequenceTransactionCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "moyenneTransactionCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "modeGestionCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "nbOperationsSansConseillerCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "risqueRendementCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "connaissancesMarcheFinancierProduitsEpargneCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "combienTempsRealisezInvestissementsCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "dejaPertePlacementCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "reactionChuteBrusqueValeurInvestissementCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericConnaissanceExperienceResponseResource.prototype, "connaissancesMarcheImmobilierCorporation", void 0);
